"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _constants = require("../../../utils/constants");

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavbarController = function () {
  function NavbarController($scope, AuthService, AppContextService, FilterService, EventsService, NavigationService) {
    "ngInject";

    (0, _classCallCheck3.default)(this, NavbarController);
    this.authService = AuthService;
    this.appContextService = AppContextService;
    this.filterService = FilterService;
    this.eventsService = EventsService;
    this.navigationService = NavigationService;

    $scope.$watch("vm.activeLocation", this.onLocationChange.bind(this), true);
  }

  (0, _createClass3.default)(NavbarController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;

      this.appContext = this.appContextService.getAppContext();
      this.activeLocation = this.appContextService.getActiveLocation();

      this.eventsService.listen(_constants2.default.events.AUTHORIZATION_SUCCESS, function () {
        _this.appContext = _this.appContextService.getAppContext();
        console.log("AUTHORIZATION_SUCCESS Event listener called", _this.appContext);
      });
    }
  }, {
    key: "onLocationChange",
    value: function onLocationChange(value) {
      this.appContextService.setActiveLocation(value);
    }
  }, {
    key: "logout",
    value: function logout() {
      this.authService.logout();
      this.appContextService.clearAppContext();
    }
  }, {
    key: "applyGlobalFilter",
    value: function applyGlobalFilter(filter) {

      for (var i = 0; i < this.globalFilterOptions.length; i++) {
        if (this.globalFilterOptions[i] == filter) this.globalFilterOptions[i].isActive = true;else this.globalFilterOptions[i].isActive = false;
      }

      this.eventsService.broadcast(_constants2.default.events.GLOBAL_FILTER_APPLIED, filter);
    }
  }]);
  return NavbarController;
}();

exports.default = NavbarController;


/** WEBPACK FOOTER **
 ** ./client/app/common/Components/navbar/navbar.controller.js
 **/